<script>
import ListViewTemplate from './ListViewTemplate'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import feedbackMixin from '../mixins/feedback'
import listViewMixin from '../mixins/list-view'

import exportFileMixin from "../mixins/export-file";

Vue.use(VueAxios, axios);

export default {
	name: 'YBLineItems',
	mixins: [feedbackMixin, listViewMixin, exportFileMixin],
	extends: ListViewTemplate,
	data() {
		return {
			primaryKey: 'Container Line Item ID',
			columns: [
				{
					name: 'Container Line Item ID',
					displayName: 'ID',
					sort: 0
				},
				{
					name: 'Container ID',
					displayName: 'Cont ID',
					searchName: 'Container ID',
					sort: 0
				},
				{
					name: 'hcn.holding_cn::Container Name',
					displayName: 'Container Name',
					sort: 0
				},
				{
					name: 'hcn.job::__PKJobID',
					displayName: 'Job ID',
					sort: 0
				},
				{
					name: 'hcn.job::Job Name',
					displayName: 'Job Name',
					sort: 0
				},
				{
					name: 'hcn.job::Company ID',
					displayName: 'Comp ID',
					searchName: 'Company ID',
					sort: 0
				},
				{
					name: 'NDC Number',
					displayName: 'NDC Number',
					sort: 0
				},
				{
					name: 'NDC Schedule',
					displayName: 'Sch',
					searchName: 'Schedule',
					sort: 0
				},
				{
					name: 'NDC Description',
					displayName: 'Description',
					sort: 0
				},
				{
					name: 'hcn.holding_li_SHOWCN_danox_dic__finalCode::Strength',
					displayName: 'Strength',
					sort: 0
				},
				{
					name: 'Pack Quantity',
					displayName: 'Pk Qty',
					searchName: 'Pack Qty',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Pack Quantity UoM',
					displayName: 'UoM',
					searchName: 'Pack Qty UoM',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Pack Size Web',
					displayName: 'Pk Size',
					searchName: 'Pack Size',
					sort: 0,
					align: 'center'
				},
				/*{
                    name: 'Reporting Qty',
                    displayName: 'Reporting Qty',
                    sort: 0,
align: 'center'
                },
                {
                    name: 'Reporting UoM',
                    displayName: 'UoM',
                    sort: 0,
align: 'center'
                },*/
				{
					name: 'Pack Size UoM Web',
					displayName: 'UoM',
					searchName: 'Pack Size UoM',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Percent Fill',
					displayName: '% Fill',
					sort: 0,
					format: '0.00%'
				},
				{
					name: 'Locked Container Line Item',
					displayName: 'Locked',
					sort: 0,
					locked: true
				},
				{
					name: 'Form 222 Number',
					displayName: 'Form 222#',
					sort: 0
				},
				{
					name: 'CWF Form Number',
					displayName: 'CWF#',
					sort: 0
				},
				{
					name: 'Source Number',
					displayName: 'Source Number',
					sort: 0
				},
				{
					name: 'Source',
					displayName: 'Source',
					sort: 0
				},
				{
					name: 'Cause',
					displayName: 'Cause',
					sort: 0
				},
				{
					name: 'Lot Number',
					displayName: 'Lot#',
					sort: 0
				},
				{
					name: 'hcn.holding_cn::Pallet',
					displayName: 'Pallet',
					sort: 0
				},
				{
					name: 'Date Created',
					displayName: 'Created',
					sort: 0
				},
				{
					name: 'Created By',
					displayName: 'By',
					searchName: 'Created By',
					sort: 0
				}
			],
			fields: [
				{
					key: 'lockedField',
					label: ''
				},
				{
					key: 'Container Line Item ID',
					label: 'ID',
					sortable: true,
					stickyColumn: true
				},
				{
					key: 'Container ID',
					label: 'Cont ID',
					searchName: 'Container ID',
					sortable: true
				},
				{
					key: 'hcn.holding_cn::Container Name',
					label: 'Container Name',
					sortable: true
				},
				{
					key: 'hcn.job::__PKJobID',
					label: 'Job ID',
					sortable: true
				},
				{
					key: 'hcn.job::Job Name',
					label: 'Job Name',
					sortable: true
				},
				{
					key: 'hcn.job::Company ID',
					label: 'Comp ID',
					searchName: 'Company ID',
					sortable: true
				},
				{
					key: 'NDC Number',
					label: 'NDC Number',
					sortable: true
				},
				{
					key: 'NDC Schedule',
					label: 'Sch',
					searchName: 'Schedule',
					sortable: true
				},
				{
					key: 'NDC Description',
					label: 'Description',
					sortable: true
				},
				{
					key: 'hcn.holding_li_SHOWCN_danox_dic__finalCode::Strength',
					label: 'Strength',
					sortable: true
				},
				{
					key: 'Pack Quantity',
					label: 'Pk Qty',
					searchName: 'Pack Qty',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Pack Quantity UoM',
					label: 'UoM',
					searchName: 'Pack Qty UoM',
					sortable: true,
					align: 'center'
				},
				/*{
                    key: 'Reporting Qty',
                    label: 'Reporting Qty',
                    sortable: true,
align: 'center'
                },
                {
                    key: 'Reporting UoM',
                    label: 'UoM',
                    sortable: true,
align: 'center'
                },*/
				{
					key: 'Pack Size Web',
					label: 'Pk Size',
					searchName: 'Pack Size',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Pack Size UoM Web',
					label: 'UoM',
					searchName: 'Pack Size UoM',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Percent Fill',
					label: '% Fill',
					sortable: true,
					format: '0.00%'
				},
				{
					key: 'Form 222 Number',
					label: 'Form 222#',
					sortable: true
				},
				{
					key: 'CWF Form Number',
					label: 'CWF#',
					sortable: true
				},
				{
					key: 'Source Number',
					label: 'Source#',
					sortable: true
				},
				{
					key: 'Lot Number',
					label: 'Lot#',
					sortable: true
				},
				{
					key: 'hcn.holding_cn::Pallet',
					label: 'Pallet',
					sortable: true
				},
				{
					key: 'Date Created',
					date: true,
					label: 'Created',
					sortable: true
				},
				{
					key: 'Created By',
					label: 'By',
					searchName: 'Created By',
					sortable: true
				}
			],
			headerTitle: 'Yellow Bucket Line Items',
			restEntity: 'yb-line-items',
			restDetailEntity: 'yb-line-item-view',
			showExport: true,
			leftmostColumn: 'cell(Container Line Item ID)',
			lockedColumn: 'Locked Container Line Item'
		}
	},
}
</script>
<style scoped>
</style>